import React from 'react'
import Sports from './Sports'
import Trending from './Trending'
import Worldsub from './Worldsub'
function Home() {
  return (
    <div>
      <Trending/>
      <Worldsub/>
      <Sports/>
    </div>
  )
}

export default Home
